import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { PharmacyInconsistencyHistory } from './models/PharmacyInconsistencyHistory';

export const PharmacyInconsistencyHistoryStore = types.compose(
  getBaseStore<Instance<typeof PharmacyInconsistencyHistory>, SnapshotIn<typeof PharmacyInconsistencyHistory>>(
    PharmacyInconsistencyHistory,
    'pharmacyInconsistencyHistoryId',
    'pharmacyInconsistencyHistory',
  ),
  types.model('PharmacyInconsistencyHistoryStore', {}),
);

export type PharmacyInconsistencyHistoryType = Instance<typeof PharmacyInconsistencyHistory>;
